<template>
    <span :class="[
    'badge',
    badgeClass
    ]">
        {{badgeDisplay}}
    </span>
</template>

<script>
export default {
    'props': {
        'statusId': {
            'required': true
        }
    },
    'computed': {
        badgeClass () {
            switch (this.statusId) {
            case 0: return 'badge-light';
            case 1: return 'badge-info';
            case 2: return 'badge-success';
            case 3: return 'badge-primary';
            case 4: return 'badge-dark';
            case 99: return 'badge-secondary';
            case 100: return 'badge-dark';
            case 998: return 'badge-danger';
            case 999: return 'badge-warning';
            case 1000: return 'badge-success';
            }
        },
        badgeDisplay () {
            switch (this.statusId) {
            case 0: return 'New';
            case 1: return 'Awaiting Pharmacy Review';
            case 2: return 'Confirmed';
            case 3: return 'In Preparation';
            case 4: return 'Delivered';
            case 99: return 'Cancelled';
            case 100: return 'Received';
            case 998: return 'Payment Required';
            case 999: return 'No Payment Received';
            case 1000: return 'Payment Success';
            }
        }
    }
};

</script>
